import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

export type HoldModalProps = {
    show: boolean;
    onHold: (reason: string, details: string) => void;
    onClose: () => void;
};

export default function HoldModal({ show, onHold, onClose }: HoldModalProps) {
    const [selectedReason, setSelectedReason] = useState("9");
    const [details, setDetails] = useState("");

    const onSave = () => {
        onHold(selectedReason, details);
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Hold
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>Reason:</h4>
                <div className="mt-4">
                    <div className="form-check mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-check-input"
                            type="radio"
                            id="radioInvalidCaseNum"
                            value="1"
                            onChange={(e) =>
                                e.currentTarget.checked &&
                                setSelectedReason(e.currentTarget.value)
                            }
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="radioInvalidCaseNum"
                        >
                            Invalid Case Number
                        </label>
                    </div>

                    <div className="form-check mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-check-input"
                            type="radio"
                            id="radioInvalidParties"
                            value="2"
                            onChange={(e) =>
                                e.currentTarget.checked &&
                                setSelectedReason(e.currentTarget.value)
                            }
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="radioInvalidParties"
                        >
                            Party Names Don't Match
                        </label>
                    </div>

                    <div className="form-check mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-check-input"
                            type="radio"
                            id="radioOrders"
                            value="3"
                            onChange={(e) =>
                                e.currentTarget.checked &&
                                setSelectedReason(e.currentTarget.value)
                            }
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="radioOrders"
                        >
                            Document not for Filing (i.e. Order)
                        </label>
                    </div>
                    <div className="form-check mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-check-input"
                            type="radio"
                            id="radioMissingNOC"
                            value="4"
                            onChange={(e) =>
                                e.currentTarget.checked &&
                                setSelectedReason(e.currentTarget.value)
                            }
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="radioMissingNOC"
                        >
                            Notice of Confidential Information Missing
                        </label>
                    </div>
                    <div className="form-check mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-check-input"
                            type="radio"
                            id="radioWrongDim"
                            value="5"
                            onChange={(e) =>
                                e.currentTarget.checked &&
                                setSelectedReason(e.currentTarget.value)
                            }
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="radioWrongDim"
                        >
                            Wrong Dimensions
                        </label>
                    </div>
                    <div className="form-check mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-check-input"
                            type="radio"
                            id="radioUserRequest"
                            value="6"
                            onChange={(e) =>
                                e.currentTarget.checked &&
                                setSelectedReason(e.currentTarget.value)
                            }
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="radioUserRequest"
                        >
                            User Request
                        </label>
                    </div>
                    <div className="form-check mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-check-input"
                            type="radio"
                            id="radioNoCaseNumber"
                            value="7"
                            onChange={(e) =>
                                e.currentTarget.checked &&
                                setSelectedReason(e.currentTarget.value)
                            }
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="radioNoCaseNumber"
                        >
                            Case Number Not Yet Assigned
                        </label>
                    </div>
                    <div className="form-check mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-check-input"
                            type="radio"
                            id="radioMissingDoc"
                            value="8"
                            onChange={(e) =>
                                e.currentTarget.checked &&
                                setSelectedReason(e.currentTarget.value)
                            }
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="radioMissingDoc"
                        >
                            Missing Pleading
                        </label>
                    </div>
                    <div className="form-check mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-check-input"
                            type="radio"
                            id="radioOther"
                            value="9"
                            checked={true}
                            onChange={(e) =>
                                e.currentTarget.checked &&
                                setSelectedReason(e.currentTarget.value)
                            }
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="radioOther"
                        >
                            Other
                        </label>
                    </div>
                    <div className="mt-1">
                        <label htmlFor="txtFailDetails">Details:</label>
                        <input
                            className="form-control"
                            type="text"
                            id="txtFailDetails"
                            onChange={(e) => setDetails(e.currentTarget.value)}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>Close</Button>
                <Button onClick={onSave}>Hold</Button>
            </Modal.Footer>
        </Modal>
    );
}
